export default __webpack_public_path__ + "23464c11092a51c2838ebbda49067c23.png";